import { bunja } from 'bunja';
import { atom } from 'jotai';
import { atomWithMutation, atomWithQuery } from 'jotai-tanstack-query';

import { getAgreementApi, postAgreementApi } from '@flipster/apis/v1/agreement';

import { authBunja } from '../../shared/auth/state';

export const pusdtAgreementBunja = bunja(() => {
  const { isCookieLoggedInAtom } = bunja.use(authBunja);
  const getAgreementApiAtom = atomWithQuery((get) => {
    return {
      queryKey: ['getAgreementApi', get(isCookieLoggedInAtom)],
      queryFn: getAgreementApi,
    };
  });

  const postAgreementApiAtom = atomWithMutation((get) => ({
    mutationKey: ['postAgreementApi'],
    mutationFn: postAgreementApi,
    onSuccess: () => {
      const { refetch } = get(getAgreementApiAtom);
      refetch();
    },
  }));

  const agreementAtom = atom((get) => get(getAgreementApiAtom).data?.data);
  const isAgreedPusdtAtom = atom((get) => get(agreementAtom)?.agreed.includes('AGREEMENT_PREMIUM_USDT'));

  const getPremiumEarnInfo = (maxApr: string) => [
    {
      title: 'Trade and Earn at the same time',
      description: 'Enjoy full flexibility. Trade and earn at the same time.',
    },
    {
      title: `Earn up to ${maxApr.toString()}% APR`,
      description: `Start with a boosted base APR and unlock up to ${maxApr.toString()}% total APR as your trading volume grows.`,
    },
    {
      title: 'Deposit and withdrawals in USDT only',
      description: 'Converting back to USDT takes 24 hours.',
    },
  ];

  return {
    agreementAtom,
    postAgreementApiAtom,
    isAgreedPusdtAtom,
    getPremiumEarnInfo,
  };
});
pusdtAgreementBunja.debugLabel = 'pusdtAgreementBunja';
